module.exports = __webpack_public_path__ + "assets/music/rock/Free will possession by XTaKeRuX.ogg";